<!-- Navigation -->
<treo-vertical-navigation class="theme-dark"
                          [appearance]="'dense'"
                          [mode]="isScreenSmall ? 'over' : 'side'"
                          [name]="'mainNavigation'"
                          [navigation]="data.navigation.default"
                          [opened]="!isScreenSmall">

                          <div treoVerticalNavigationContentHeader>
                            <div class="logo">
                                <img src="assets/images/logo/logo.png">
                            </div>
                        </div>
</treo-vertical-navigation>

<!-- Wrapper -->
<div class="wrapper">

    <!-- Header -->
    <div class="header cor-master">

        <!-- Navigation toggle button -->
        <button  class="navigation-toggle-button"
                mat-icon-button
                (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'menu'"></mat-icon>
        </button>


        <div class="flex flex-col">
            <span class="font-semibold text-lg">{{titulo}}</span>
         <span class="text-secondary text-sm">{{subtitulo}}</span>
        </div>


        <!-- Spacer -->
        <div class="spacer"></div>

        <!-- Search -->
        <!-- <search [appearance]="'bar'"></search> -->

        <!-- Shortcuts -->
        <!-- <shortcuts [shortcuts]="data.shortcuts"></shortcuts> -->

        <!-- Messages -->
        <!-- <messages [messages]="data.messages"></messages> -->

        <!-- Notifications -->
        <!-- <notifications [notifications]="data.notifications"></notifications> -->

        <!-- Jogos -->


        <!-- <button routerLink="/regras" class="mr-1 ml-auto" mat-icon-button>
            <mat-icon class="icon-size-24" [svgIcon]="'mat_outline:assignment_late'"></mat-icon>
        </button>

        <button (click)="reload()" class="mr-1 ml-auto" mat-icon-button>
            <mat-icon class="icon-size-24" [svgIcon]="'refresh'"></mat-icon>
        </button> -->
        <user [user]="data.user" [showAvatar]="true"></user>

    </div>

    <!-- Content -->
    <div class="content">

        <!-- *ngIf="true" hack is required here for router-outlet to work correctly. Otherwise,
             it won't register the changes on the layout and won't update the view. -->
        <router-outlet *ngIf="true"></router-outlet>

    </div>

    <!-- Footer -->
    <div *ngIf='!isScreenSmall' class="footer">
        Master Bets
    </div>

    <div *ngIf="isScreenSmall && usuario.tipo != 'Cliente'" class="footer justify-between">
        <div routerLink="/jogos" class="flex flex-col">
            <button class="align-center">
                <mat-icon class="icon-size-24 text-master" [svgIcon]="'mat_outline:sports_soccer'"></mat-icon>
            </button>
        </div>

        <div *ngIf="usuario.tipo == 'Administrador' || usuario.tipo == 'Vendedor'" routerLink="/caixa" class="flex flex-col">
            <button class="align-center">
                <mat-icon class="icon-size-24 text-master" [svgIcon]="'mat_outline:account_balance_wallet'"></mat-icon>
            </button>
        </div>

        <div *ngIf="usuario.tipo == 'Administrador' || usuario.tipo == 'Gerente'" routerLink="/financeiro" class="flex flex-col">
            <button class="align-center">
                <mat-icon class="icon-size-24 text-master" [svgIcon]="'mat_outline:monetization_on'"></mat-icon>
            </button>
        </div>

        <div class="flex flex-col" routerLink="/bilhetes">
            <button class="align-center">
                <mat-icon class="icon-size-24 text-master" [svgIcon]="'mat_outline:receipt'"></mat-icon>
            </button>
            <!-- <span class="font-bold">Bilhetes</span> -->
        </div>
    </div>

</div>
